
<section class="container-fluid summary-panel">

    <app-data-list [loadPage]="loadPageForLoad" [(filters)]="filters" [filtersBase]="filtersBase" [itemTemplate]="itemTemplate" [extraActionFields]="assignFrom"
                   [filtersComponent]="dataFilters" [pageSize]="10"
                   (onPageChange)="pageChanged()" (onLoad)="onLoad($event)">
        <app-data-filters #dataFilters [opened]="true" [fullWidth]="true" [titleKey]="'local-loads.reorder.search.page-title'">
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-multi-string-input [labelKey]="'local-loads.search.list.filters.shipment-number.label'"
                                            [placeholderKey]="'local-loads.search.list.filters.shipment-number.placeholder'"
                                            [separators]="[',', ';']"
                                            [(model)]="filters.shipment_number">
                </app-data-filter-multi-string-input>
                <app-data-filter-date [labelKey]="'local-loads.search.list.filters.updated.start.label'" [(model)]="startDate"
                                      [maxDate]="endDate" [placeholderKey]="'local-loads.search.list.filters.updated.start.placeholder'"
                                      (modelChange)="updateStartDateFilter()"></app-data-filter-date>

                <app-data-filter-date [labelKey]="'local-loads.search.list.filters.updated.end.label'" [(model)]="endDate"
                                      [minDate]="startDate" [placeholderKey]="'local-loads.search.list.filters.updated.end.placeholder'"
                                      (modelChange)="updateEndDateFilter()"></app-data-filter-date>
                <app-data-filter-autocomplete [labelKey]="'local-loads.search.list.filters.vehicle.label'"
                                              [name]="'vehicle'"
                                              [(model)]="filters.vehicles" [options]="vehicleSearchOptions"
                                              [placeholderKey]="'local-loads.search.list.filters.vehicle.placeholder'"
                                              [notFoundTextKey]="'local-loads.search.list.filters.vehicle.notfound'"
                                              [multiple]="true" [useOptionValueExtractor]="true">
                </app-data-filter-autocomplete>
                <app-data-filter-switch class="data-filter-switch"
                                        [labelKey]="'local-loads.search.list.filters.vehicle.unassigned'"
                                        [(model)]="filters.showUnassigned"></app-data-filter-switch>
            </app-data-filter-group>


        </app-data-filters>
        <ng-template #assignFrom let-items="items">
            <div *ngIf="selectedVehicle" class="assign-from-container">
                <i (click)="assignAllToVehicle(assignLocalLoads, items)" class="fas fa-angle-double-left fa-2x"></i>
            </div>
        </ng-template>
        <ng-template #itemTemplate let-item="item">
            <div class="ibox float-e-margins loads-list">

                <div class="ibox-title collapsible border-primary"
                     [class.collapsed]="!item.expanded"
                     (click)="item.expand()">
                    <div class="local-load-list-item">

                        <div *ngIf="selectedVehicle" class="local-load-list-item-column control-buttons shrink">
                            <i (click)="assignLoad(item)" class="fas fa-angle-left fa-lg"></i>
                        </div>
                        <div class="local-load-list-item-column mainInfos">
                            <div class="local-load-list-item">
                                <div class="local-load-list-item-column">
                                    <div [title]="item.shipmentNumbers" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.shipment-numbers',
                                         params: {shipmentNumbers: item.shipmentNumbers}}]">
                                </div>
                                </div>
                                <div class="local-load-list-item-column">
                                    <div [title]="item.loadNumber">
                                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.load-number'}]"></span>
                                        <span>#{{ item.loadNumber }}</span>
                                        <span class="item-blujay-logo" *ngIf="item.localLoadImport.source === 'BLUJAY'">
                                            <img class="blujay-logo" src="/assets/blujay-logo.png" alt="BluJay"/>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="local-load-list-item">
                                <div class="local-load-list-item-column shipmentInfos">
                                    <div class="ellipsisInfos" [title]="item.stops[0].location.name" >
                                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-from',
                                              params: {location: item.stops[0].location.name}}]">
                                        </span>
                                    </div>
                                    <div class="ellipsisInfos" [title]="item.stops[item.stops.length - 1].location.name" >
                                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-to',
                                              params: {location: item.stops[item.stops.length - 1].location.name}}]">
                                        </span>
                                    </div>
                                </div>
                                <div class="local-load-list-item-column shrink">
                                    <app-local-load-status [status]="item.status"></app-local-load-status>
                                    <div class="driverInfos">
                                        <i class="fa fa-truck"></i>
                                        <span *ngIf="item.vehicle; else unassigned">{{ item.vehicle }}</span>
                                        <ng-template #unassigned>
                                            <span><em [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.unassigned_load'}]"></em></span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="local-load-list-item-column shrink">
                            <div class="ibox-tools">
                                <a class="collapse-link" draggable="false">
                                    <i class="fa" [ngClass]="{ 'fa-plus': !item.expanded, 'fa-minus': item.expanded }"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ibox-content no-padding local-load-list-item-stops" *ngIf="item.expanded">
                    <div *ngFor="let stop of item.stops" class="local-load-list-item-stop"
                         [ngClass]="{ 'active': selectedStop === stop }">
                        <div *ngIf="stop.type === 'Pick'" [title]="stop.location.name" class="local-load-list-item-stop-location">
                            <span class="chep-icon-pick-up"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-from',
                                  params: {location: stop.location.name}}]"></span>
                        </div>
                        <div *ngIf="stop.type === 'Drop'" [title]="stop.location.name" class="local-load-list-item-stop-location">
                            <span class="chep-icon-drop-off"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.deliver-to',
                                  params: {location: stop.location.name}}]"></span>
                        </div>
                        <div [title]="stop.plannedArrival | fullDate" class="local-load-list-item-stop-arrival">
                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.planned-arrival',
                              params: { date: stop.plannedArrival | fullDate: false }}]"></span>
                        </div>
                        <div [title]="stop.plannedDeparture | fullDate" class="local-load-list-item-stop-departure">
                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.planned-departure',
                              params: { date: stop.plannedDeparture | fullDate: false }}]"></span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-data-list>
</section>

<ng-template #assignLocalLoads>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.reorder.modal.assign.body', params: { vehicle: selectedVehicle }}]"></span>
</ng-template>
